import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import RemoteProjectsScreen from '@/components/Settings/RemoteProjectsScreen';
export default function RemoteProjectsRoute() {
  const { colors } = useTheme();
  return <View style={{ flex: 1, backgroundColor: colors.solid_color_primary }}><RemoteProjectsScreen workspace /></View>;
}
